import { advertisersRoutes } from 'pages/Advertisers/routes/routes'
import { campaignsRoutes } from 'pages/Campaigns/routes/routes'
import { creativesRoutes } from 'pages/Creatives/routes/routes'
import { lineItemsRoutes } from 'pages/LineItems/routes/routes'
import { eventsRoutes } from 'pages/Events/routes/routes'
import { dealsRoutes } from 'pages/Deals/routes/routes'
import { listsRoutes } from 'pages/Lists/routes/routes'
import { dashboardRoutes } from 'pages/Dashboard/routes/routes'
import { reportCenterRoutes } from 'pages/ReportCenter/routes/routes'
import { billingRoutes } from 'pages/Billing/routes/routes'
import { registerRoutes } from 'pages/Register/routes/routes'
import { loginRoutes } from 'pages/Login/routes/routes'

const routes = [
  {
    name: 'home',
    redirect: () => ({ name: 'advertisers' }),
  },
  {
    component: () => import('layouts/MainLayout/index.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      advertisersRoutes,
      creativesRoutes,
      campaignsRoutes,
      dealsRoutes,
      eventsRoutes,
      lineItemsRoutes,
      listsRoutes,
      dashboardRoutes,
      reportCenterRoutes,
    ],
  },
  {
    component: () => import('layouts/BlankLayout/index.vue'),
    children: [registerRoutes, loginRoutes, billingRoutes],
  },
  {
    path: '/setting',
    name: 'setting',
    component: () => import('pages/ErrorNotFound.vue'),
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
]

export default routes
